import { FormControl } from '@@/form-components/FormControl';
import { PortainerSelect } from '@@/form-components/PortainerSelect';

import { DriftMode } from '../../types';

const options = [
  {
    label: 'Report drift',
    value: 'warn' as const,
  },
  {
    label:
      'Reconcile drift (automatically erase out of band changes back to Git state)',
    value: 'enabled' as const,
  },
];

/**
 * Chooses what happens when a resource on the cluster stops matching its source.
 *
 * Reporting is the default because detection changes nothing and a deployment
 * that silently diverged is the failure worth surfacing. Forcing puts the
 * resource back on the next interval, which is what someone editing a Deployment
 * by hand will notice.
 *
 * Turning detection off entirely is a wire value the engine still honours, but
 * not one this offers: a deployment nothing looks at is what the engine exists
 * to prevent.
 */
export function DriftConfiguration({
  value,
  onChange,
}: {
  value: DriftMode;
  onChange: (next: DriftMode) => void;
}) {
  return (
    <FormControl
      label="Drift detection"
      tooltip="Checked on every reconcile interval. Correcting re-applies only the resources that changed, and for a Helm release does so without creating a new revision."
      inputId="drift-mode"
    >
      <PortainerSelect
        inputId="drift-mode"
        data-cy="workflow-drift-mode-select"
        value={value}
        options={options}
        onChange={(next) => onChange((next as DriftMode) ?? 'warn')}
      />
    </FormControl>
  );
}
